module.exports = __webpack_public_path__ + "img/hacienda-resort-5.b05a953c.jpg";